// Tenant-scoped routes (`/:tenantId/...`) have no canActivate guard, so the
// canActivate write to `completeAuthenticationUrl` doesn't fire on cold-load
// deep links. Call this once at bootstrap so auth-callback + tenant.state
// land the user back on the requested URL.
export function captureDeepLinkUrl(): void {
    if (sessionStorage.getItem('completeAuthenticationUrl')) return;
    const url = window.location.pathname + window.location.search;
    if (!url || url === '/') return;
    if (url.startsWith('/auth-callback')
        || url.startsWith('/auth-signout-callback')
        || url.startsWith('/silent-refresh')) return;
    sessionStorage.setItem('completeAuthenticationUrl', url.slice(1));
}
